import { render, staticRenderFns } from "./LpuInformation.vue?vue&type=template&id=147c9377&scoped=true&"
import script from "./LpuInformation.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuInformation.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuInformation.vue?vue&type=style&index=0&id=147c9377&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147c9377",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('147c9377')) {
      api.createRecord('147c9377', component.options)
    } else {
      api.reload('147c9377', component.options)
    }
    module.hot.accept("./LpuInformation.vue?vue&type=template&id=147c9377&scoped=true&", function () {
      api.rerender('147c9377', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuInformation/LpuInformation.vue"
export default component.exports